<template>
  <div
    :class="{
      'is-min-width-700': !isDuplication,
      'is-min-width-500': isDuplication,
    }"
    class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ title }}
          </h1>
        </div>
      </div>
    </div>
    <div class="card-content">
      <error-msg-component
        :messages="messages"
        :messagesChampsVide="messagesChampsVide"
        :champsVide="champsVide"
        :error="error"
        @close="error = $event"
        title="general.problemOccurred"
        withEmplyFields/>
      <div class="columns is-multiline">
        <b-field
          v-if="!isDuplication"
          :label="$t('listeParution.generationParutions.premierNumero')"
          class="column is-4 mgb-0">
          <b-input
            v-model="payload.premierNumero"
            :use-html5-validation="false"
            type="number"
            min="1"/>
        </b-field>
        <b-field
          :label="$t('listeParution.generationParutions.qteACreer')"
          class="column mgb-0 obligatoire">
          <b-input
            v-model="payload.qteACreer"
            :use-html5-validation="false"
            type="number"
            min="1"/>
        </b-field>
        <b-field
          v-if="!isDuplication"
          :label="$t('listeParution.generationParutions.periodicite')"
          class="column is-4 mgb-0">
          <b-select
            v-model="periodiciteSelect"
            @input="actionPeriodiciteSelect"
            expanded>
            <option
              v-for="periodicite in periodicites"
              :key="periodicite.id"
              :value="periodicite">
              {{periodicite.libelle}}
            </option>
          </b-select>
        </b-field>
        <b-field
          v-if="!isDuplication"
          :label="$t('listeParution.generationParutions.nbJours')"
          class="column is-6 mgb-0">
          <b-input
            v-model="payload.nbJours"
            :use-html5-validation="false"
            @input="payload.nbMois = null"
            type="number"
            min="1"/>
        </b-field>
        <b-field
          v-if="!isDuplication"
          :label="$t('listeParution.generationParutions.nbMois')"
          class="column is-6 mgb-0">
          <b-input
            v-model="payload.nbMois"
            :use-html5-validation="false"
            @input="payload.nbJours = null"
            type="number"
            min="1"/>
        </b-field>
      </div>
      <footer>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="generer()">
              {{ $t('general.button.sauvegarder') }}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { generationParutions } from '@/api/presse/parution';
import messageErreur from '@/services/general/messageErreur';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/presse/parution/translatorParution';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import validationParution from '@/services/presse/parution/validationParution';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    items: {
      type: Array,
      require: true,
    },
    isDuplication: {
      type: Boolean,
    },
  },
  components: {
    errorMsgComponent,
  },
  data() {
    return {
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      periodiciteSelect: null,
      payload: {
        premierNumero: null,
        qteACreer: 1,
        nbJours: null,
        nbMois: null,
        isDuplication: false,
      },
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    periodicites() {
      return this.parametre(PARAMETRES_KEYS.periodicite);
    },
    title() {
      let prefix = 'listeParution.generationParutions.';
      if (this.isDuplication) prefix += 'titleDuplication';
      else prefix += 'titleGenration';
      return this.$t(prefix);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    actionPeriodiciteSelect() {
      if (this.periodiciteSelect) {
        this.payload.nbJours = this.periodiciteSelect.nbJour;
        this.payload.nbMois = this.periodiciteSelect.nbMois;
      }
    },
    async generer() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.payload.isDuplication = this.isDuplication;
        await generationParutions({
          ...this.payload,
          parutionsIds: this.items.map(item => item.id),
        });
        loadingComponent.close();
        this.$emit('reload');
        this.$parent.close();
      } catch (e) {
        if (e.response.data.error) {
          validationParution(e.response, this.messages, this.$i18n, translate);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
        }
        loadingComponent.close();
        throw e;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (!this.isDuplication) await this.loadParametres([PARAMETRES_KEYS.periodicite]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
